import React from 'react'
import Dashboard from '../components/Dashboard'

const inicio = () => {
  return (
    <Dashboard />
  )
}

export default inicio